'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var Row = require('../Row/Row.js');

var RenderRows = function (props) {
    var rows = props.rows, generateRow = props.generateRow, _a = props.hoverable, hoverable = _a === void 0 ? false : _a, _b = props.rowsClickable, rowsClickable = _b === void 0 ? false : _b, _c = props.rowClick, rowClick = _c === void 0 ? function () { return undefined; } : _c;
    return (React__default.createElement(React__default.Fragment, null, rows.map(function (row) {
        return (React__default.createElement(Row, { key: row.id, rowId: row.id, rowCells: generateRow(row), hasmaxwidth: row.hasmaxwidth, hoverable: hoverable, isActive: row.isActive, clickable: rowsClickable, colSpan: row.colSpan, onClick: function () { return rowClick(row); } }));
    })));
};

module.exports = RenderRows;
